export function ErrorIcon() {
  return <img src="/pictures/error-icon.png" alt="error-icon" />;
}
